// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2H_o5","content":"Consent_content__3nqgW","footer":"Consent_footer__2ONqt"};